<template>
  <div class="creek-donate-panel">

    <div v-if="config">

      <!-- <a :href="userSignInURL" class="donate-sign-in" v-html="text.sign_in_link"></a> -->

      <div class="donate-intro-message fclear">
        <h1 v-html="text.main_heading"></h1>
        <img 
          v-if="banners.banner_top_image_url" 
          class="donate-intro-banner-image" 
          :src="banners.banner_top_image_url"
        />
        <p class="donate-intro-message">
          <span class="donate-intro-message-text" v-html="text.intro"></span>
          <div v-if="text.intro_more">
            <span 
              class="donate-intro-message-text-more" 
              v-html="text.intro_more" 
              v-if="ui.display_intro_more"
            ></span>
            <a 
              class="read-more" 
              @click="ui.display_intro_more = true" 
              v-if="!ui.display_intro_more"
            >
              Read more
            </a>
            <a 
              class="read-less" 
              @click="ui.display_intro_more = false" 
              v-if="ui.display_intro_more"
            >
              <i class="fa fa-arrow-up"></i>
              Hide
            </a>
          </div>
        </p>
      </div> <!-- End #support-message -->

      <div class="input-radio-button-container donation-type-selector">

        <label 
          class="input-radio-button" 
          @click="updateDonationType('recurring', levels.selected_amount)" 
          :class="{ 
            'input-radio-button-selected': levels.selected_type == 'recurring' 
          }"
        >
          <div class="input-radio-button-fake">
            <div class="input-radio-button-fake-inner"></div>
          </div>
          <input 
            class="donation-type-radio-input" 
            name="donation-type" 
            type="radio" 
            value="recurring"
          >
          <span v-html="text.recurring_title"></span>
        </label>
        <span class="donation-type-recurring-why">
          <a @click="toggleRecurringWhy()" v-html="text.recurring_why_link"></a>
        </span>
        <label 
          class="input-radio-button" 
          @click="updateDonationType('single', levels.selected_amount)" 
          :class="{ 
            'input-radio-button-selected': levels.selected_type == 'single' 
          }"
        >
          <div class="input-radio-button-fake">
            <div class="input-radio-button-fake-inner"></div>
          </div>
          <input 
            class="donation-type-radio-input" 
            name="donation-type" 
            type="radio" 
            value="single"
          >
          <span v-html="text.single_title"></span>
        </label>
        
      </div>

      <div v-if="ui.display_recurring_why" class="donation-recurring-why">
        <p v-html="text.recurring_why"></p>
      </div>

      <div 
        class="donation-form-container donation-container-recurring" 
        :style="{
          display: levels.selected_type == 'recurring' ? 'block' : 'none' 
        }"
      >
        
        <!--

          gifts.selected.name

          quantity

          amountTotal

          convertOptionsToReadableString(optionsSelected)

          custom_recurring
        
        -->
        
          <ul class="input-radio-button-container donation-levels">
            <li v-for="level in levels.recurring">
              <label 
                class="input-radio-button" 
                :class="{
                  'input-radio-button-selected': levels.selected_amount == level
                }" 
                @click="updateDonationType('recurring', level)"
              >
                <input 
                  class="donation-level-radio-input" 
                  type="radio" 
                  :value="level"
                >
                <span v-html="currency_symbol+level"></span>/mo
              </label>
            </li>
            <li 
              class="donation-custom-amount donation-custom-input" 
              :class="{'custom-amount-active': levels.selected_amount === 0}"
            >
              <span class="donation-dollar-sign" v-html="currency_symbol"></span>
              <input 
                @focus="onCustomAmountInputFocus" 
                type="text" 
                class="donation-custom-amount-input" 
                v-model="levels.custom_recurring" 
                :placeholder="text.recurring_custom_placeholder"
              >
            </li>
          </ul>


      </div>


      <div 
        class="donation-form-container donation-container-single" 
        :style="{display: levels.selected_type == 'single' ? 'block' : 'none' }"
      >

          <ul class="input-radio-button-container donation-levels">
            <li v-for="level in levels.single">
              <label 
                class="input-radio-button" 
                :class="{
                  'input-radio-button-selected': levels.selected_amount == level
                }" 
                @click="updateDonationType('single', level)"
              >
                <input 
                  class="donation-level-radio-input"
                  type="radio" 
                  :value="amountTotal"
                >
                <span v-html="currency_symbol+level"></span>
              </label>
            </li>
            <li 
              class="donation-custom-amount donation-custom-input" 
              :class="{'custom-amount-active': levels.selected_amount === 0}"
            >
              <span class="donation-dollar-sign" v-html="currency_symbol"></span>
              <input 
                @focus="onCustomAmountInputFocus" 
                type="text" 
                class="donation-custom-amount-input" 
                v-model="levels.custom_single" 
                :placeholder="text.single_custom_placeholder"
              >
            </li>
          </ul>

      </div>

      <section 
        class="donation-section-gifts"
        v-if="config.gifts && config.gifts.list"
      >

        <h2 class="donation-heading" v-html="text.thank_you_heading"></h2>

        <div 
          class="donation-gifts-gallery-container input-radio-button-container" 
          v-if="ui.show_gifts_as_gallery"
        >
          <ul class="donation-gifts">
            <li class="donation-gift-item">
              <label 
                class="input-radio-button" 
                data-gift="None" 
                @click="setGift(gifts.none)"
              >
                <div class="ribbon"><span>100%</span></div>
                <input 
                  type="radio" 
                  name="gift" 
                  value="None" 
                  data-minimum-recurring="5" 
                  data-minimum-single="5"
                >
                <div class="title" v-html="gifts.none.title"></div>
                <div class="level">
                  <p v-html="gifts.none.description"></p>
                </div>
                <div class="buttons">
                  <div 
                    class="button" 
                    :class="[ 
                      isGiftSelected(gifts.none) ? 
                        'button-primary-inverse' : 'button-primary'
                    ]"
                  >
                    Choose
                  </div>
                </div>
              </label>
            </li>
            <li class="donation-gift-item" v-for="(gift, index) in gifts.list">
              <label 
                class="input-radio-button" 
                :data-gift="gift.name" 
                @click="setGift(gift)"
              >
                <input 
                  type="radio" 
                  name="gift" 
                  :value="gift.name" 
                  :data-minimum-recurring="gift.level.recurring" 
                  :data-minimum-single="gift.level.single"
                >
                <div class="image-container">
                  <img class="small" :src="gift.imageURL">
                </div>
                <div class="title" v-html="gift.title"></div>
                <div class="level">
                  <p>
                    <span 
                      v-html="currency_symbol+gift.level[levels.selected_type]"
                    ></span>
                    <span v-if="levels.selected_type=='recurring'"> monthly</span>
                  </p>
                </div>
                <div 
                  class="fine-print" 
                  v-if="gift.finePrint" 
                  v-html="gift.finePrint"
                ></div>
                <div class="buttons">
                  <div 
                    class="button" 
                    :class="[ 
                      isGiftSelected(gift) ? 
                        'button-primary-inverse' : 'button-primary' 
                    ]"
                  >
                    Choose
                  </div>
                </div>
              </label>
            </li>
          </ul>
        </div>

        <div 
          class="donation-gifts-list-container input-radio-button-container" 
          v-if="!ui.show_gifts_as_gallery"
        >
          <ul 
            class="donation-gifts" 
          >
            
            <li>
              <label 
                class="input-radio-button" 
                data-gift="None" 
                @click="setGift(gifts.none)"
              >
                <div class="input-radio-button-fake">
                  <div class="input-radio-button-fake-inner"></div>
                </div>
                <p class="donation-no-gift">
                  <input 
                    type="radio" 
                    name="gift" 
                    value="None" 
                    data-minimum-recurring="5" 
                    data-minimum-single="5"
                  >
                  <b>No gift for me.</b> 
                  Please make 100% of my gift tax-deductible.
                </p>
              </label>
            </li>
            <li class="donation-gift-item" v-for="gift in gifts.list">
              <label 
                class="input-radio-button" 
                :data-gift="gift.name" 
                @click="setGift(gift)"
              >
                <input 
                  type="radio" 
                  name="gift" 
                  :value="gift.name" 
                  :data-minimum-recurring="gift.level.recurring" 
                  :data-minimum-single="gift.level.single"
                >
                <div class="input-radio-button-fake">
                  <div class="input-radio-button-fake-inner"></div>
                </div>
                <a class="expand" href="javascript:">More Info</a>
                <div class="image-container">
                  <img class="small" :src="gift.imageURL">
                </div>
                <div class="title" v-html="gift.title"></div>
                <div class="level">
                  <p>
                    <span 
                      v-html="currency_symbol+gift.level[levels.selected_type]"
                    ></span>
                    <span v-if="levels.selected_type=='recurring'"> monthly</span>
                  </p>
                </div>
                <div 
                  class="fine-print" 
                  v-if="gift.finePrint" 
                  v-html="gift.finePrint"
                ></div>
                <div class="description">
                  <img class="large" :src="gift.imageURL">
                  <p v-html="gift.description"></p>
                </div>
              </label>
            </li>
          
          </ul>
          
        </div>

      </section>


      <section 
        class="donation-section-email"
      >

        <h2 class="donation-heading">Your email address</h2>
        <div class="">
          <input class="donation-email-input" v-model="email" @input="checkEmail" />
          <!-- <span v-if="ui.isEmailCheckLoading"><b>Checking...</b></span> -->
        </div>
        <p class="donation-email-help">
          For receipts sent by email<span v-if="levels.selected_type == 'recurring'"> and for managing your monthly donation</span>.
          Your email is kept private.
        </p>

        <div v-if="hasStripeCustomer && hasStripeSubscription" class="donation-sign-in-container">
          <!-- <p v-if="!hasStripeSubscription">Welcome back! If you want to see your past donations, click the button below.</p> -->
          <p v-if="hasStripeSubscription">Welcome back! You already have a monthly donation. To update it, click the button below.</p>
          <button class="button-large button button-primary-inverse" @click="sendEmail()">
            <span v-if="!ui.isEmailSendLoading && !ui.isSendButtonSent">Send Sign-in Link</span>
            <span v-if="ui.isEmailSendLoading && !ui.isSendButtonSent">Sending...</span>
            <span v-if="ui.isSendButtonSent">Sent.</span>
          </button>
          <p class="donation-email-help" v-if="ui.isEmailSent">We're emailing a <b>Sign-in Link</b> to you. Please check your spam folder. If you don't receive it within a few minutes, try pressing the Send button again, or contact us.</p>
        </div>

      </section>

      <section 
        class="donation-section-options" 
        v-if="gifts.selected.options"
      >
        <h2 class="donation-heading" v-html="text.optionsTitle"></h2>
        <div class="donation-options-container">
          <p v-for="(optionValues, optionName, optionIndex) in gifts.selected.options">
            <!-- <h4 v-if="optionName" v-text="optionName"></h4> -->
            <button 
              v-if="optionValues && optionName && optionValue"
              v-for="optionValue in optionValues" 
              v-text="optionValue" 
              @click="setOption(optionName, optionValue)"
              :class="{ 
                isSelected: optionsSelected[optionName] 
                  && optionsSelected[optionName] == optionValue
              }"
            ></button>
          </p>
        </div>
      </section>

      <section 
        class="donation-section-quantity" 
        v-if="gifts.selected.allowQuantity"
      >
        <h2 class="donation-heading" v-html="text.quantityTitle"></h2>
        <div 
          class="donation-quantity-container" 
          :class="{'active': quantity > 1}"
        >
          <input 
            type="number" 
            class="donation-quantity-input" 
            v-model="quantity"
          >
        </div>
      </section>

      <div class="donation-summary-and-payment">

        <section class="donation-section-summary">

          <h2 class="donation-heading" v-html="text.summary_heading"></h2>

          <p>
            <label>Amount:</label> 
            <span v-html="currency_symbol+amountDonation"></span>
          </p>
          <p>
            <label>Type:</label> 
            <span v-html="text[levels.selected_type+'_title']"></span>
          </p>
          <p v-if="config.gifts && config.gifts.list && config.gifts.list.length > 0">
            <label>Gift:</label> 
            <span v-html="gifts.selected.name || gifts.none.name"></span>
          </p>
          <p>
            <label>Shipping:</label>
            <span 
              v-if="amountShipping" 
              v-html="currency_symbol+amountShipping"
            ></span>
            <span v-else v-html="text.shipping_free_label"></span>
          </p>
          <p>
            <label>Quantity:</label> 
            <span v-html="quantity"></span>
          </p>
          <p v-for="(optionValue, optionName) in optionsSelected">
            <label v-text="capitalizeFirstLetter(optionName) + ':'"></label> 
            <span v-html="optionValue"></span>
          </p>
          <p class="donation-summary-total">
            <label>Total:</label> 
            <span v-html="currency_symbol+amountTotal"></span>
          </p>

        </section>
        
        <section class="donation-section-payment">

          <div class="donation-payment-method-container" v-if="hell">
            <div class="donation-payment-method">
              
              <div class="donation-inner">
                <h2 
                  class="donation-heading" 
                  v-html="text.payment_method_heading"
                ></h2>
              </div>

              <div class="donation-inner" v-if="payments.card.enabled">

                <label 
                  class="input-radio-button" 
                  @click="updatePaymentMethod('card')" 
                  :class="{
                    'input-radio-button-selected': payment_method == 'card'
                  }"
                >
                  <div class="input-radio-button-fake">
                    <div class="input-radio-button-fake-inner"></div>
                  </div>
                  <input 
                    class="donation-type-radio-input" 
                    name="donation-type" 
                    type="radio" 
                    value="card"
                  >
                  <div class="credit-card-inner">
                    <i class="fa fa-credit-card"></i>
                    &nbsp
                    <span v-html="text.payment_method_card_title"></span>
                    <!--<div class="donation-credit-card-logos-container ">
                      <img src="/img/credit-card-logos.png" />
                    </div>-->
                  </div>
                </label>
                
              </div>
              
              <div class="donation-inner" v-if="payments.paypal.enabled">
              
                <label 
                  class="input-radio-button" 
                  @click="updatePaymentMethod('paypal')" 
                  :class="{ 
                    'input-radio-button-selected': payment_method == 'paypal' 
                  }"
                >
                  <div class="input-radio-button-fake">
                    <div class="input-radio-button-fake-inner"></div>
                  </div>
                  <input 
                    class="donation-type-radio-input" 
                    name="donation-payment-method" 
                    type="radio" 
                    value="paypal"
                  />
                  <i class="fa fa-paypal paypal"></i> 
                  &nbsp 
                  <span 
                    v-html="text.payment_method_paypal_title" 
                    class="paypal"
                  ></span>
                </label>
                
              </div>
              
            </div>
          </div>

        </section>

        <section class="donation-section-submit">

          <div class="donation-submit-container">
            <button 
              id="donate-main-submit-button" 
              type="button" 
              v-html="text.submit_button_name" 
              class="button button-large button-primary-inverse" 
              @click="submitForm()"
            ></button>
            <p 
              class="submit-note" 
              v-html="text['submit_note_'+payment_method]"
            ></p>
          </div>

        </section>

      </div>

    </div> <!-- END Check for "config" -->

  </div>
</template>

<script>

import _ from "lodash"
import $ from "jquery"
import isoCountries from "@creek-website-toolkit/lib/donate/iso-country-codes.js"
import axios from "axios"

export default {

  name: 'CreekDonatePanel',
  
  props: {
    config: {
      type: Object,
      default: {}
    }
  },
  
  data: function() {
    return {

      amount: {
        donation: 0.00,
        shipping: 0.00,
        total: 0.00
      },
      
      user: {
        country_code: null,
        country_name: null
      },
      
      currency_symbol: "$",
      currency_code: "USD",

      payment_method: "card",
      // payment_method: "paypal",

      quantity: 1,

      optionsSelected: {},

      userSignInURL: _.get(this.config, 'userSignInURL'),

      email: null,

      stripeExistingCustomer: {},

      payments: {
        // paypal: _.get(this.config, 'payments.payPal') || {},
        paypal: {
          enabled: false,
        },
        card: {
          enabled: true,
          gateway_url: "https://kkrn.donate.creek.org/stripe/donate",
          return_url: "https://www.kkrn.org/",
          thanks_url: "https://www.kkrn.org/",
        },
        default: _.get(this.config, 'payments.default') || {},
      },

      international_shipping: { 
        enabled: false,
        checked: false,
        amount: 15.00,
        home_country_code: "US" //freegeoip country code is in CAPS
      },

      levels: {
        single: _.get(this.config, 'levels.single'),
        recurring: _.get(this.config, 'levels.recurring'),
        custom_recurring: '',
        custom_single: '',
        // selected_type: "single",
        // selected_amount: 100.00,
        defaultAmounts: {
          single: 50,
          recurring: 20,
        },
        selected_amount: 15.00,
        selected_type: "recurring",
      },

      gifts: {
        selected: {},
        none: {
          name: "None",
          title: "No gift for me.",
          // title: "None",
          imageURL: "",
          description: "Make 100% of my contribution support the station.",
          // description: "None.",
          level: {
            single: 0,
            recurring: 0
          },
          none: true
        },
        list: _.get(this.config, 'gifts')
      },
      banners: {
        banner_top_image_url: _.get(this.config, 'bannerTopURL'),
      },
      text: {
        main_heading: _.get(this.config, 'text.mainHeading'),
        intro: _.get(this.config, 'text.intro'),
        intro_more: _.get(this.config, 'text.introMore'),
        single_message: "",
        shipping_title: "Shipping Options",
        quantityTitle: "Quantity",
        optionsTitle: "Options",
        shipping_free_label: "FREE",
        international_shipping_label: "International gift shipping - Add $15",
        // international_shipping_description: "We must add $15 shipping and handling to international orders outside of the United States.",
        international_shipping_description: "For one-time donations, we must add $15 shipping and handling to international orders outside of the United States.",
        international_shipping_detected: "We've detected that your country is: ",
        single_custom_placeholder: "Other amount",
        recurring_title: "Monthly Donation",
        recurring_custom_placeholder: "Other monthly amount",
        recurring_why_link: "Why monthly?",
        recurring_why: _.get(this.config, 'text.recurringWhy'),
        single_title: "One-time Donation",
        recurring_message: "",
        payment_method_heading: "Payment Method",
        payment_method_card_title: "Card",
        payment_method_paypal_title: "PayPal",
        intro_expanded: "Expanded description.",
        thank_you_heading: "Choose a Thank-You Gift",
        submit_button_name: "Continue &rarr;",
        // submit_note: "You can use both <b>credit cards</b> and <b>PayPal</b> at our PayPal gateway.",
        // submit_note_card: "You will be taken to our <b>credit card</b> gateway to complete your payment.",
        // submit_note_paypal: "You will be taken to our <b>PayPal</b> gateway to complete your payment.",
        submit_note_card: "Continue to our <b>credit card</b> form to complete donation.",
        // submit_note_card: "Continue to our <b>credit card</b> form to complete your donation.",
        submit_note_paypal: "Continue to <b>PayPal</b> to complete your donation.",
        error_select_donation_level: "Please select a donation level.",
        error_donation_too_low_for_gift: "Please select a higher donation level for this gift.",
        summary_heading: "Summary",
        sign_in_link: "Member Sign In",
      },
      ui: {
        show_gifts_as_gallery: _.get(this.config, 'showGiftsAsGallery'),
        display_intro_more: 0,
        display_recurring_why: 0,
        isEmailSent: false,
        isEmailCheckLoading: false,
        isEmailSendLoading: false,
        isSendButtonSent: false,
      },
      // COUNTRY CODE => COUNTRY NAME CONVERSION
      isoCountries
    }
  },

  //Data values computed from data above, plus form inputs
  computed: {

    selectedGiftInfo: function() {

      if(!this.gifts.selected || !this.gifts.selected.name){
        return ''
      }

      let info = this.gifts.selected.name
      
      // Add quantity to gift info.
      info += ` | Quantity: ${quantity}`

      // Add options to gift info.
      if(this.optionsSelected){
        for(optionName in optionsSelected){
          const optionValue = optionsSelected[optionName]
          info += ` | ${capitalizeFirstLetter(optionName)}: ${optionValue}`
        }
      }

      return info

    },

    amountShipping: function() {

      var total = 0.00

      total += this.amount.shipping

      //Tally the shipping
      if (
        this.international_shipping.enabled 
        && this.internationalShippingTest()
        && this.international_shipping.checked 
        && this.gifts.selected 
        && this.gifts.selected.name
        && !this.gifts.selected.none
        && this.levels.selected_type == 'single' 
        ) {
        total += this.international_shipping.amount
      }

      //Disable shipping if recurring.
      if (this.levels.selected_type == "recurring") {
        total = 0.00
      }

      return total

    },

    amountDonation: function() {

      var total = 0.00

      var custom_amount = this.levels["custom_" + this.levels.selected_type] * 1

      //Tally up the amounts
      if (custom_amount) {
        total = custom_amount * 1
      } else {
        total = this.levels.selected_amount * 1
      }

      return total

    },

    amountTotal: function() {

      var total = (this.amountShipping + this.amountDonation) * this.quantity

      return total

    },

    thanksURLParsed: function () {
      
      //Replace variables
      return this.payments.card.thanks_url
        .replace(/{{donation-type}}/g, this.levels.selected_type)
        .replace(/{{donation-amount}}/g, this.amountTotal)

    },

    hasStripeCustomer(){
      if(
        this.stripeExistingCustomer
        && this.stripeExistingCustomer.customer
      ){
        return true
      }

      return false
    },

    hasStripeSubscription() {

      if(
        this.stripeExistingCustomer
        && this.stripeExistingCustomer.customer
        && this.stripeExistingCustomer.subscription
      ){
        return true
      }

      return false

    }

  },

  methods: {

    // Adding method to set selected_amount to 0 if custom amount
    // input element is clicked (@focus). If "selected_amount === 0"
    // we apply special styling to input el.
    onCustomAmountInputFocus: function() {
      this.levels.selected_amount = 0
    },

    setGift: function(gift) {

      this.gifts.selected = gift

      // Reset other values:
      this.quantity = 1
      this.optionsSelected = {}

      // console.log("Setting gift: " + gift.name)

    },

    setOption: function(optionName, optionValue) {

      this.optionsSelected[optionName] = optionValue
      
      this.$forceUpdate()

    },

    isGiftSelected: function(gift) {

      return gift.name == this.gifts.selected.name

    },

    onGiftDetailsChooseClick: function(gift, index) {

      // $.magnificPopup.close() 

      this.setGift(gift)

    },

    updateDonationType: function(type, amount) {

      this.levels.selected_type = type
      this.levels.selected_amount = amount

      if (type == 'recurring') {
        this.levels.custom_recurring = ''
      } else if (type == 'single') {
        this.levels.custom_single = ''
      }

    },

    updatePaymentMethod: function(method) {

      this.payment_method = method

      // alert(this.payment_method)

    },

    //Open or close the "why" explanation for monthly donations.
    toggleRecurringWhy: function() {

      if (this.ui.display_recurring_why) {

        this.ui.display_recurring_why = 0

      } else {

        this.ui.display_recurring_why = 1

      }

    },

    //Open or close the "why" explanation for monthly donations.
    toggleInternationalShipping: function() {

      if (this.international_shipping.checked) {

        this.international_shipping.checked = false

      } else {

        this.international_shipping.checked = true

      }

      // console.log(this.international_shipping.checked)

    },

    internationalShippingTest: function() {

      if (!this.user.country_code || this.user.country_code != this.international_shipping.home_country_code) {

        return true

      }

      return false

    },

    //Make sure that they have a donation level selected, either single or recurring.
    async submitForm() {

      var form_to_submit = this.levels.selected_type

      //---------------------------------------------
      // Donation and gift amount validation:
      //---------------------------------------------
      //
      // Too low for gift:
      if (
        this.gifts.selected.level
        && this.amountDonation < this.gifts.selected.level[this.levels.selected_type]
      ){
        alert(this.text.error_donation_too_low_for_gift)
        return false
      }
      // No amount selected:
      if (!this.amountDonation) {
        alert(this.text.error_select_donation_level)
        return false
      }

      //---------------------------------------------
      // Submit donation!
      //---------------------------------------------

      const postData = {
        giftName: this.gifts.selected.name || "",
        email: this.email,
        amount: this.amountTotal,
        isRecurring: this.levels.selected_type == 'recurring' ? 1 : 0,
        stripeCustomerId: this.stripeExistingCustomer.customer ? this.stripeExistingCustomer.customer.id : undefined,
        shipping: this.amountShipping,
        returnURL: this.payments.card.return_url,
        thanksURL: this.thanksURLParsed
      }

      //Test this to see if they switch properly
      // window.location.href = payment_url
      const postResponse = await axios.post(
        this.payments.card.gateway_url, postData
      )


      if(postResponse.data.stripe_checkout_url){
        window.location = postResponse.data.stripe_checkout_url
      }

    },

    getCountryName(a){
      return isoCountries.hasOwnProperty(a) ? isoCountries[a] : a
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    async checkEmail(){
      this.ui.isEmailCheckLoading = true
      const response = await axios.post(
        'https://kkrn.donate.creek.org/stripe/get-customer-by-email', 
        { email: this.email } 
      )

      this.ui.isEmailCheckLoading = false

      this.stripeExistingCustomer = response.data

      // console.log(email)
      // console.log(this.email)
    },

    async sendEmail(){

      this.ui.isEmailSendLoading = true

      let response = null

      try {
        response = await axios.post(
          'https://kkrn.donate.creek.org/stripe/send-sign-in-link', 
          { cid: this.stripeExistingCustomer.customer.id }
        )
      }catch(error){

      }

      console.log(this.stripeExistingCustomer.customer.id)

      this.ui.isEmailSendLoading = false
      this.ui.isEmailSent = true
      this.ui.isSendButtonSent = true

      setTimeout(() => {
        this.ui.isSendButtonSent = false
      }, 3000)

    },

  },
  created: function() {

    // alert(13)

    this.payment_method = this.payments.default

    // Default to no gift selected.
    this.gifts.selected = this.gifts.none
    
    this.levels.selected_type = "single"
    
    // Set the default amount.
    this.levels.selected_amount = this.levels.defaultAmounts[
      this.levels.selected_type
    ]

    // this.levels.selected_amount = 15 // !!! DEFAULT
    // this.levels.selected_type = "recurring"

    var parentThis = this;

    if (this.international_shipping.enabled) {

      $.get("https://ipinfo.io", function (response) {
          //Set user's country so that Vue can display the international shipping UI.
          const country = response.country;
          const homeCountry = parentThis.international_shipping.home_country_code;
          parentThis.user.country_code = country;
          parentThis.user.country_name = getCountryName(country);

          if (country.toLowerCase() != homeCountry.toLowerCase()) {
            parentThis.international_shipping.checked = true;
            parentThis.international_shipping.enabled = true;
          }
      }, "jsonp");

    }

  },

  mounted: function() {

    // $('.donation-gifts .button-more').magnificPopup({
    //   type: 'inline',
    //   midClick: true
    // });

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    //---------------------------------------------------
    //
    // Settings used by the code below.
    //
    // !!! TODO: Integrate this into Vue above.
    //
    //---------------------------------------------------

    var Donate = {}

    Donate.settings = {

      minimum: {
        single: 1.00,
        recurring: 1.00
          // single: 5.00,
          // recurring: 5.00
      }

    }


    //---------------------------------------------------
    // Public Methods
    //---------------------------------------------------

    Donate.methods = {

      inputs: {
        radio: {

          clearGroup: function(group) {

            //Remove selection class from the other radio button in this group
            group
              .find("label.input-radio-button")
              .removeClass("input-radio-button-selected")

            //Remove "checked" attribute from other radio button inputs in this group
            group
              .find("input[type=radio]")
              .prop("checked", false)
              // .trigger("change")

          },

          select: function(element) {

            //Get the container
            var group = element.closest(".input-radio-button-container")

            //Clear all of the radio buttons in this group
            Donate.methods.inputs.radio.clearGroup(group);

            //Add selection class to this one
            element.addClass("input-radio-button-selected")

            //Add "checked" status to the actual, selected radio button
            // so that it works for the HTML form.
            element
              .find("input[type=radio]")
              .prop("checked", true)
              .trigger("change")

          }

        }

      }

    }


    //Handle functions that should load after the page loads.
    $(function() {

      //Handle tricky, legacy PayPal inputs when radio buttons change:
      //
      // - "a3" is for recurring payments
      // - "amount" is for single payment
      //
      $("body").on("change", ".donation-level-radio-input", function() {

        // get the current button's group name
        var name = $(this).attr("data-name")

        // console.log(name)

        var type
        var other_type

        //Recurring donation amount selected
        if (name == "a3") {
          type = "recurring"
          other_type = "single"
        }
        //Single donation amount selected
        else if (name == "amount") {
          type = "single"
          other_type = "recurring"
        }

        Donate.methods.inputs.radio.clearGroup($("#donation-form-" + other_type + " .donation-levels"))
        $("#donation-form-to-submit").val(type)
        $("#donation-custom-" + type + "-value").val('')
        $(".donation-custom-amount-input").val('')
        // $(".donation-quantity-input").val('')

      })


    })


    //Handle changes in custom donation amounts (recurring and single)
    $(document).on("change", ".donation-custom-amount-input", function() {

      //Set up the "is it a number?" function
      function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
      }

      //Set up variables
      var amount = $(this).val()
      var donation_type = $(this).closest("form").attr("data-donation-type")

      //If the amount is blank, then do nothing
      if (amount === '') {
        // alert('Please enter an amount. Our minimum donation level is $'+Donate.settings.minimum[donation_type]+'.')
        return false
      }
      //If the amount is not actually a number
      if (!isNumber(amount)) {
        alert('Amount must be a number.')
        return false
      }
      //If amount is too small
      if (parseFloat(amount) < (Donate.settings.minimum[donation_type] - 0.0001)) {
        alert('Amount must be a minimum of $' + Donate.settings.minimum[donation_type] + '.')
        return false
      }

      //Validation checked out, so continue:

      //Un-select all of the radio buttons
      $(".donation-levels.input-radio-button-container").map(function() {
        Donate.methods.inputs.radio.clearGroup($(this))
      })

      //Fill in the hidden custom amount value
      $("#donation-custom-" + donation_type + "-value").val(amount)

      //Set the form to submit (single or recurring)
      $("#donation-form-to-submit").val(donation_type)

      return true

    })


    //Handle the fancy radio buttons.
    $(document).on("click", ".input-radio-button", function() {

      Donate.methods.inputs.radio.select($(this))

    })



    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

@import "../../sass/donate.sass"

</style>
